import * as React from 'react';

import {MergeItemsModal} from 'shells/modal/merge-items-modal/merge-items-modal';

import {
    LeadCardDynamicWrapper,
    DEFAULT_LEAD_CARD_FIELDS_WITH_NUMBER,
    getLeadCardStatusString,
} from '../../lead/lead-card-dynamic';

type Props = {
    allItems: any[];
    selectedItems: string[];
    onMergeLeads: (selectedLeadId: string, selectedItems: string[]) => any;
    onClose: () => any;
};

export class LeadMergeModal extends React.Component<
    Props,
    {
        isMerging: boolean;
        entities: any[];
    }
> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isMerging: false,
            entities:
                props.selectedItems.length > 0
                    ? props.selectedItems.map((id) => Nut.Model.Leads.findOrCreate({id}))
                    : props.allItems.map((id) => Nut.Model.Leads.findOrCreate({id})),
        };
    }

    UNSAFE_componentWillMount() {
        this.state.entities.forEach((entity) =>
            entity.fetch().done(() => {
                this.forceUpdate();
            })
        );
    }

    render() {
        return (
            <MergeItemsModal
                title='Merge leads into one'
                subtitle='Select a lead to absorb all details from the rest of the leads.'
                infoText='Double-check before merging. Combining two or more leads is irreversible!'
                mergeButtonText='Merge leads'
                mergingText='Merging…'
                isMerging={this.state.isMerging}
                items={this.state.entities}
                renderItem={(item) => {
                    const listItem = this.deserializeItemToLeadCard(item);

                    return (
                        <LeadCardDynamicWrapper
                            listItem={listItem}
                            hasActionMenu={false}
                            linkable={false}
                            isLoading={Boolean(!listItem)}
                            fieldsToDisplay={DEFAULT_LEAD_CARD_FIELDS_WITH_NUMBER}
                        />
                    );
                }}
                onMergeItems={(selectedLead) => this.handleMergeClick(selectedLead.id)}
                onClose={this.props.onClose}
                maxHeight={600}
            />
        );
    }

    handleMergeClick = (selectedLeadId: string) => {
        if (!selectedLeadId) return;
        this.setState({isMerging: true});
        this.props.onMergeLeads(selectedLeadId, this.props.selectedItems);
        this.props.onClose();
    };

    deserializeItemToLeadCard(item: any) {
        let listItem;

        // @ts-expect-error
        const wrapValue = (field) => ({value: field});

        if (item.get('name')) {
            const contacts = item.get('contacts');
            const contactsValue =
                contacts.length > 0
                    ? [
                          {
                              value: {
                                  id: contacts.models[0].attributes.id,
                                  name: contacts.models[0].attributes.name,
                                  type: contacts.models[0].attributes.type,
                                  htmlUrl: contacts.models[0].attributes.htmlUrl,
                              },
                          },
                      ]
                    : null;
            const accounts = item.get('accounts');
            const accountsValue =
                accounts.length > 0
                    ? [
                          {
                              value: {
                                  id: accounts.models[0].attributes.id,
                                  name: accounts.models[0].attributes.name,
                                  type: accounts.models[0].attributes.type,
                                  htmlUrl: accounts.models[0].attributes.htmlUrl,
                              },
                          },
                      ]
                    : null;
            const owner = item.getOwner();

            listItem = {
                primaryName: item.get('name'),
                avatarUrl: item.get('avatarUrl'),
                htmlUrl: item.get('htmlUrl'),
                htmlUrlPath: item.get('htmlUrlPath'),
                priority: item.get('priority') === 1 ? 'Hot' : 'Normal',
                fields: {
                    number: wrapValue(item.get('number')),
                    status: wrapValue({value: getLeadCardStatusString(item.get('status'))}),
                    value: wrapValue(item.get('value') ? item.get('value').formatted : ''), // TODO: format value for lead card header
                    owner: wrapValue(owner !== null ? owner.attributes : null),
                    accounts: wrapValue(accountsValue),
                    contacts: wrapValue(contactsValue),
                },
                links: {
                    entity: {
                        id: item.id,
                    },
                },
            };
        }

        return listItem;
    }
}
